<template>
  <div class='page-start'>
    <mdb-container class="col-10 pb-3" fluid>
      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
        Success! Approved QPR!
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
          There was an error approving the QPR. Please try again! Error Code P2
      </mdb-alert>
      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p3" @closeAlert="p3=false" dismiss>
        Success! Rejected QPR!
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p4" @closeAlert="p4=false" dismiss>
          There was an error rejecting the QPR. Please try again! Error Code P4
      </mdb-alert>
      
        <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Quadrus Corporation QPRs</h3>
        <mdb-card-body>
          <div>
            <mdb-row>
              <mdb-col v-if="isPM || isAdmin || isCM || isDev" class="col-3">
                <mdb-input v-if="isPM" class="mb-0 mt-2" type="checkbox" v-model="showReview" id="showReview" name="showReview" 
                :label="showClosed ? 'View Closed QPRs' : 'Review Open QPRs'" 
                @click.native.prevent="handleToggle('review')"/>
                <mdb-input v-else class="mb-0 mt-2" type="checkbox" v-model="showReview" id="showReview" name="showReview" 
                :label="showClosed ? 'View All Closed QPRs' : 'View All Open QPRs'" 
                @click.native.prevent="handleToggle('review')"/>
              </mdb-col>
              <mdb-col v-if="isPM || isAdmin || isCM || isDev" class="col-3" style="border-right: 1px solid #e0e0e0">
                <mdb-input class="mb-0 mt-2" type="checkbox" v-model="showSubmitted" id="showSubmitted" name="showSubmitted" label="View Your Submitted QPRs" 
                @click.native.prevent="handleToggle('submitted')"/>
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-0 mt-2" type="checkbox" id="showClosed" name="showClosed" v-model="showClosed" @change="populateQPRData" label="Show Closed QPRs"/>
              </mdb-col>
            </mdb-row>
            <hr>
          </div>

          <br>
          <h4>Advanced Filtering</h4>
          <div id="filterOptions" v-for="(item, index) in qprFilterOptions" :key="item.id">
            <mdb-row v-if="filterNumber >= index + 1">
              <mdb-col>
                <mdb-select id="filterDropdown" class="mb-3" v-model="item.options" ref="filterDropdown" @getValue="setVal" label="Filter Options"/>   
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-3" v-model="filterVal[index]" @change="setFilterVal(index, filterVal[index])" :disabled="!item.set" label="Search for"/>
              </mdb-col>
            </mdb-row>
          </div>

          <mdb-row class="offset-4">
            <mdb-col >
              <mdb-btn class="mt-4 roundButton" color="info" type="submit" v-on:click="addFilter">+</mdb-btn>  
              <mdb-btn class="mt-4 roundButton" color="info" type="submit" v-on:click="removeFilter">-</mdb-btn>  
            </mdb-col>
            <mdb-col></mdb-col>
          </mdb-row><br>

          <mdb-row>
            <mdb-col class="d-flex align-items-center justify-content-center">
              <mdb-btn size="block" class="mt-4" color="secondary" style="width: 50%;" type="submit" v-on:click="resetFilter">Clear Filter</mdb-btn>  
            </mdb-col>
            <mdb-col class="d-flex align-items-center justify-content-center">
              <mdb-btn size="block" class="mt-4 QuadrusButton" style="width: 50%;" type="submit" v-on:click="searchFilter">Apply Filter</mdb-btn>  
            </mdb-col>
          </mdb-row>
          <br><br>


          <div ref="mainTable">
            <QDataTable id='qprTable' :rowData="this.qprData.rowData" :filterWords="this.qprData.filterWords" :headers="this.qprData.columns" 
            :btnName="'Review QPR'" :hasBtn="true" @use-method='previewQPR' :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
            </QDataTable>
          </div>

          <div :class="{'hideSpinner': isSetUp}" class="p-4">
            <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
          </div>
        </mdb-card-body>
        </mdb-card>
    

      <div ref="preview" v-if="previewing">
      <mdb-card  class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">QPR Preview</h3>
        <mdb-card-body>
          <mdb-row>
            <mdb-col col="1">
              <mdb-input class="mb-3 readonly-inputs" v-model="qprNumber" label="QPR Number" readOnly/>
            </mdb-col>
            <mdb-col col="9">
              <mdb-input class="mb-3 readonly-inputs" v-model="title" label="Title" readOnly/>
            </mdb-col>
            <mdb-col col="2">
              <mdb-input class="mb-3 readonly-inputs" v-model="author" label="Author" readOnly/>
            </mdb-col>
          </mdb-row>
          <br>
          <mdb-row>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="foundIn" label="Found In" readOnly/>
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="softwareVersion" label="Software Version" readOnly />
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="foundDuring" label="Found During" readOnly/>
            </mdb-col>
            <!--<mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="constraintOn" label="Constraint On" readOnly/>
            </mdb-col>-->
          </mdb-row>
          <mdb-row>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="userAssignedPriority" label="User Submitted Priority" readOnly />
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="dateCreated" label="Date Created" readOnly/>
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="companyName" label="Company Name" readOnly/>
            </mdb-col>
          </mdb-row>
          <br>
          <mdb-row>
            <mdb-col>
              <mdb-input class="mb-3 no-resize-textarea" outline type='textarea' :rows="6" v-model="currentFunction" label="Current Functionality" readOnly />
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-3 no-resize-textarea" outline type='textarea' :rows="6" v-model="expectedFunction" label="Expected Functionality" readOnly />
            </mdb-col>
          </mdb-row>
          <br><br>
          
          <div v-if="showClosed || (showReview && isPM)">
            <h4>Review</h4>
            <hr>
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="missingFields" @closeAlert="missingFields=false" dismiss>
                Missing the required Priority field.
            </mdb-alert>
            <form @submit.prevent="" class="was-validated">
            <mdb-row>   
              <mdb-col class="col-4">
                <div v-if="isPM">
                  <mdb-select v-if="!showClosed" id="pmDropdown" class="mb-3" v-model="priorityOptions" @getValue="setPriority" 
                  label="Set Priority" required/>
                  <div class="invalid-feedback d-block" v-if="!showClosed && !this.priority">Please select a priority</div>
                  <div class="valid-feedback d-block" v-if="!showClosed && this.priority">Looks Good</div>
                </div>
                <mdb-input v-if="showClosed" class="mb-3 readonly-inputs" v-model="status" label="Status" readOnly />
                <mdb-input v-if="showClosed" class="mb-3 readonly-inputs" v-model="dateReviewed" label="Review Date" readOnly />
              </mdb-col>
              <mdb-col class="col-8">
                <mdb-input outline type='textarea' :rows="4" v-model="pmComments" label="Reviewer Comments" maxlength="500" :readOnly="showClosed"/>
              </mdb-col>
            </mdb-row>
            </form>
          </div>
          
          <mdb-row v-if="showReview && isPM && !showClosed">
            <mdb-col class="d-flex align-items-center justify-content-center">
              <mdb-btn size="block" class="mt-4" color="danger" style="width: 50%;" type="submit" v-on:click="rejectQPR">Disapprove QPR</mdb-btn>
            </mdb-col>
            <mdb-col class="d-flex align-items-center justify-content-center">
              <mdb-btn size="block" class="mt-4 QuadrusButton" style="width: 50%;" type="submit" v-on:click="approveQPR">Approve QPR</mdb-btn>
            </mdb-col>
          </mdb-row>
          
          <br>
        </mdb-card-body>
      </mdb-card>
      </div>

    </mdb-container>
  </div>
</template>
<style>
.no-resize-textarea > textarea {
  height: 120px !important;
  max-height: 120px !important;
  overflow-y: auto !important;
  resize: none !important;
}
.readonly-inputs input{
  cursor: text !important;
}
</style>
<script>
import { mdbInput, mdbCard, mdbCardBody, mdbContainer, mdbRow, mdbCol, mdbBtn,mdbAlert,mdbSelect } from 'mdbvue';
import QDataTable from '@/components/QDataTable.vue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import * as sendEmail from '@/assets/js/email.js';
import * as sanitizeInput from '@/assets/js/sanitizeInput.js';

export default {
	name: 'View-QPRs',
	components: {
    mdbInput,
    mdbCard,
    mdbCardBody,
    mdbContainer,
    QDataTable,
    mdbRow,
    mdbCol, 
    mdbBtn,
    mdbAlert,
    mdbSelect
  },

  data() {
    return {
      p1: false,
      p2: false,
      p3: false,
      p4: false,
      isSetUp: false,
      missingFields: false,

      priorityOptions: [{text: "1", value: "1"},{text:"2", value: "2"},{text:"3", value: "3"},{text:"4", value: "4"},{text:"5", value: "5"}],
      showClosed: false,
      showSubmitted: false,
      showReview: false,
      previewing: false,
      filterOptions: false,
      isPM: false,
      isCM: false,
      isAdmin: false,
      isDev: false,

      dateCreated: '',
      priority: '',
      qprNumber: '',
      title: '',
      author: '',
      foundIn: '',
      softwareVersion: '',
      foundDuring: '',
      currentFunction: '',
      pmComments: '',
      expectedFunction: '',
      approvingPM: '',
      status: '',
      userAssignedPriority: '',
      companyName: '',
      authorUsername: '',
      dateReviewed: '',

      filterNumber: 1,
      filterVal: ["","","","","","",""],
      filterChoices: [],
      qprFilterOptions: [],

      pmProjects: '',

      qprData: {
        columns: [  
          {
            colTitle: 'QPR Number',
            sortBy: 'id'
          },
          {
            colTitle: 'Date Created',
            sortBy: 'dateCreated'
          },
          {
            colTitle: 'Title',
            sortBy: 'title'
          },
          {
            colTitle: 'Found In',
            sortBy: 'foundIn'
          },
          {
            colTitle: 'Software Version',
            sortBy: 'softwareVersion'
          },
          {
            colTitle: 'Found During',
            sortBy: 'foundDuring'
          },
          {
            colTitle: 'Disposition',
            sortBy: 'status'
          },
          {
            colTitle: 'Status',
            sortBy: 'closed'
          },
          {
            colTitle: 'Action',
            sortBy: ''
          }
        ],
        rowData: [],
        filterWords: [
          'id',
          'dateCreated',
          'title',
          'foundIn',
          'softwareVersion',
          'foundDuring',
          'status',
          'closed'
        ]
      }

    }
  },
  methods: {
    //sets priority value
    setPriority: function(value){
      this.priority = value;
    },

    setVal: function(value){
      let i = 0;
      let choice = "";
      for(var x = 0; x < this.qprFilterOptions.length; x++){
        i = this.qprFilterOptions[x].options.findIndex((v => v.value == value));
        if(i >= 0){
          choice = this.qprFilterOptions[x].options[i].text;
          break;
        }
      }

      let index = this.filterChoices.findIndex((v => v.id == x));
      if(index >= 0){
        this.filterChoices[index].choice = choice
      } else if(x < 7 && x >= 0) {
        this.qprFilterOptions[x].set = true;
        this.filterChoices.push({id: x, choice: choice, text: ''})
      }
    },

    setFilterVal: function(x, val){
      let index = this.filterChoices.findIndex((v => v.id == x));
      if(index >= 0){
        this.filterChoices[index].text = val;
      }
    },

    addFilter: function(){
      if(this.filterNumber != 7){
        this.filterNumber++;
      }
    },
    removeFilter: function(){
      if(this.filterNumber != 1){
        this.filterNumber--;
        this.filterChoices.splice(this.filterNumber,1)
        this.filterVal[this.filterNumber] = '';
      }
    },

    //===========================================================================================
    //	Method Name	:	searchFilter
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Searches the QCR table
    //===========================================================================================
    searchFilter: async function(){
      this.previewing = false;
      this.$nextTick(function() {
        this.$refs.mainTable.scrollIntoView({behavior: 'smooth'})
      })
      await this.populateQPRData();
      
      //let filter_Constraint = "";
      let filter_foundDuring = "";
      let filter_foundIn = ""
      let filter_version = "";
      let filter_status = "";
      let filter_title = "";
      let filter_qprNum = "";

      for(var x = 0; x < this.filterChoices.length; x++){
        if(this.filterChoices[x].choice == "QPR Number"){
          filter_qprNum = this.filterChoices[x].text;
        } /*else if(this.filterChoices[x].choice == "Constraint On"){
          filter_Constraint = this.filterChoices[x].text;
        }*/ else if(this.filterChoices[x].choice == "Found During"){
          filter_foundDuring = this.filterChoices[x].text;
        }else if(this.filterChoices[x].choice == "Found In"){
          filter_foundIn = this.filterChoices[x].text;
        }else if(this.filterChoices[x].choice == "Version"){
          filter_version = this.filterChoices[x].text;
        }else if(this.filterChoices[x].choice == "Disposition"){
          filter_status = this.filterChoices[x].text;
        }else if(this.filterChoices[x].choice == "Title"){
          filter_title = this.filterChoices[x].text;
        }
      }

      this.qprData.rowData = this.qprData.rowData.filter(row =>
        (filter_qprNum == "" ||
          (row.id == filter_qprNum)) &&
        (filter_title == "" ||
          (row.title ?? "").toLowerCase().includes(filter_title.toLowerCase())) &&
        (filter_foundDuring == "" ||
          (row.foundDuring ?? "").toLowerCase().includes(filter_foundDuring.toLowerCase())) &&
        (filter_foundIn == "" ||
          (row.foundIn ?? "").toLowerCase().includes(filter_foundIn.toLowerCase())) &&
        (filter_version == "" ||
          (row.softwareVersion ?? "").toLowerCase().includes(filter_version.toLowerCase())) &&
        (filter_status == "" ||
          (row.status ?? "").toLowerCase() == (filter_status.toLowerCase()))
      );

    },

    //===========================================================================================
    //	Method Name	:	resetFilter
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Resets the QCR table and filter values
    //===========================================================================================
    resetFilter: function(){
      this.filterVal = ["","","","","","",""];
      this.filterChoices = [];
      this.filterNumber = 1;
      this.filterChoice = '';
      this.previewing = false;

      this.qprFilterOptions = [];
      let options = [];
      for(var i = 0; i < 7; i++){
        options = [{text: "QPR Number", value: "QPRnumber"+i},{text: "Title", value: "title"+i},
          {text:"Found In", value: "foundIn"+i},{text:"Version", value: "version"+i},
          {text: "Found During", value: "foundDuring"+i},
          {text: "Disposition", value: "disposition"+i}];
        this.qprFilterOptions.push({id: i, options: options, set: false});  
      }      
      this.populateQPRData();
    },

    handleToggle: function(type) {
      if (type === 'review') {
        if (this.showReview) {
          this.showSubmitted = true;
          this.showReview = false;
        } else{
          this.showSubmitted = false;
          this.showReview = true;
        }       
      } else if(type === 'submitted') {
        if (this.showSubmitted) {
          this.showSubmitted = false;
          this.showReview = true;
        } else {
          this.showSubmitted = true;
          this.showReview = false;
        }
      } 
      this.previewing = false;
      this.populateQPRData();
    },


    resetData: function(){
      this.previewing = false;
      this.priorityOptions = [{text: "1", value: "1"},{text:"2", value: "2"},{text:"3", value: "3"},{text:"4", value: "4"},{text:"5", value: "5"}];
      this.priority = '';
      this.missingFields = false;
    },

    //===========================================================================================
    //	Method Name	:	populateQPRData
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Gets QPRs for the table
    //===========================================================================================
    populateQPRData: async function() {
      this.isSetUp = false;
      let token = this.$store.getters.getToken;
      let query = '';
      let employeeQPRs = '';

      // submitted QPRs
      query = "filters[authorUsername][$eq][0]="+this.$store.getters.getUser;
      employeeQPRs = await DatabaseLib.getRequest('strapiDatabase','submitted-qpr',token,query,false);

      if(this.isPM){
        let response = await DatabaseLib.getRequest('strapiDatabase','users/me',token);
        this.approvingPM = response.data.firstName + " " + response.data.lastName;
        query = "filters[ProjectManager][$eq][0]="+this.$store.getters.getUser;
        this.pmProjects = await DatabaseLib.getRequest('strapiDatabase','projects',token,query,false);
      }

      this.showClosed = document.getElementById('showClosed').checked;
      
      if(this.isPM){
        this.showSubmitted = document.getElementById('showSubmitted').checked;
        this.showReview = document.getElementById('showReview').checked;
      }      

      try {
        const token = this.$store.getters.getToken;
        const params = {
          showClosed: this.showClosed,
          showSubmitted: this.showSubmitted,
          showReview: this.showReview,
          pmProjects: this.pmProjects.data ? this.pmProjects.data.data: [],
          employeeQPRs: employeeQPRs.data ? employeeQPRs.data.data: [],
          isPM: this.isPM,
          isCM: this.isCM,
          isDev: this.isDev,
          userId: this.$store.getters.getUser,
        };

        const data = await DatabaseLib.postRequest("strapiDatabase","submitted-qpr/bulk-load",token,params);
        this.qprData.rowData = data.data.qprData;
        this.isSetUp = true;
      } catch(error) {
        this.isSetUp = true;
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }
      
    },

    //===========================================================================================
    //	Method Name	:	preview QPR
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Loads data for a QPR for viewing
    //===========================================================================================
    previewQPR: function(data) {
      this.resetData();
      this.qprNumber = data.id;
      this.title = data.title;
      this.dateCreated = data.dateCreated;
      this.author = data.author;
      this.foundIn = data.foundIn;
      this.softwareVersion = data.softwareVersion;
      this.foundDuring = data.foundDuring;
      this.currentFunction = data.currentFunction;
      this.pmComments = data.pmComments;
      this.expectedFunction = data.expectedFunction;
      this.userAssignedPriority = data.userAssignedPriority;
      this.companyName = data.companyName;
      this.authorUsername = data.authorUsername;
      this.status = data.status;
      this.dateReviewed = data.dateReviewed;

      this.previewing = true;
      this.$nextTick(function() {
        this.$refs.preview.scrollIntoView({behavior: 'smooth'})
      })
    },

    sendEmails: async function(status) {
      let token = this.$store.getters.getToken;
      let query = "filters[username][$eq][0]="+ this.authorUsername;
      let response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
      let email = "";
      if(response.data.length > 0) {
        email = response.data[0].email;
        let emailNotification = "QPR #" + this.qprNumber + " has been closed.<br>Title: " + this.title + "<br>Status: " + status;
        emailNotification += "<br>Reviewed By: " + this.approvingPM + "<br>Reviewer Comments: " + this.pmComments;
        try{
          await sendEmail(email, "QPR Closed", emailNotification, token, "ViewSubmittedQPR&id="+this.qprNumber, []);
        } catch(e){
          console.log(e);
        }
      }
    },

    //===========================================================================================
    //	Method Name	:	rejectQPR
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Handles QPRs that have been rejected
    //===========================================================================================
    rejectQPR: async function(){
      // close QPR
      let token = this.$store.getters.getToken;

      this.pmComments = sanitizeInput(this.pmComments, this.$sanitize);

      let data = {
        data: {
          closed: true,
          approvingPM: this.approvingPM,
          dateReviewed: new Date(),
          status: "Disapproved",
          pmComments: this.pmComments,
        }
      }
      try {     
        await DatabaseLib.putRequest('strapiDatabase','submitted-qpr',token,this.qprNumber,data);
      } catch(error) {
        window.scroll({top: 0, behavior: 'smooth'});
        this.p4 = true;
        return;
      }
      this.deleteMsgs();
      await this.sendEmails("Disapproved");
      //close preview, update table
      this.resetData();
      this.populateQPRData();
      this.p3 = true;
      window.scroll({top: 0, behavior: 'smooth'});
    },

    //===========================================================================================
    //	Method Name	:	approveQPR
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Handles QPRs that have been approved
    //===========================================================================================
    approveQPR: async function(){
      // create QCR, close QPR
      let token = this.$store.getters.getToken;

      if(!this.priority) {
        this.missingFields = true;
        return;
      }

      this.pmComments = sanitizeInput(this.pmComments, this.$sanitize);
      this.priority = sanitizeInput(this.priority, this.$sanitize);
      
      let data = {
        data: {
          closed: true,
          approved: true,
          approvingPM: this.approvingPM,
          dateReviewed: new Date(),
          pmComments: this.pmComments,
          status: "Approved"
        }
      }
      try {
        await DatabaseLib.putRequest('strapiDatabase','submitted-qpr',token,this.qprNumber,data);
        // new QCR
        let data2 = {
          data:{
            dateCreated: new Date(),
            priority: this.priority,
            CCB1: false,
            rejected: false,
            submitted_qpr: this.qprNumber,
            selectedDisposition: "Pending",
            status: "",
            closed: false
          }
        }
        await DatabaseLib.postRequest('strapiDatabase','qcrs',token,data2);
      } catch(error) {
        window.scroll({top: 0, behavior: 'smooth'});
        this.p2 = true;
        return;
      }
      this.deleteMsgs();
      await this.sendEmails("Approved");
      //close preview, update table
      this.resetData();
      this.populateQPRData();
      this.p1 = true;
      window.scroll({top: 0, behavior: 'smooth'});
    },

    deleteMsgs: async function(){
      let token = this.$store.getters.getToken;

      //delete notifications
      let query = "filters[id][$in][0]=" + this.qprNumber + "&populate[1]=notifications";
      let response = await DatabaseLib.getRequest('strapiDatabase','submitted-qpr',token,query,false);
      for(var i = 0; i < response.data.data[0].attributes.notifications.data.length; i++){
        await DatabaseLib.deleteRequest('strapiDatabase','notifications',token,response.data.data[0].attributes.notifications.data[i].id);
      }

      // remove notifications from QPR
      let data = {
        data: {
          notifications: []
        }
      }
      await DatabaseLib.putRequest('strapiDatabase','submitted-qpr',token,this.qprNumber,data);
      // Load notifications
      this.bus.$emit('fireMethod');
    },

    //===========================================================================================
    //	Method Name	:	checkPM
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Checks to see if user is a PM
    //===========================================================================================
    checkPM: function(){
      if (this.$store.getters.getGroups.includes("Project Manager")){
        this.isPM = true;
      }
      if (this.$store.getters.getGroups.includes("CM")){
        this.isCM = true;
      }
      if (this.$store.getters.getGroups.includes("Developer")){
        this.isDev = true;
      }
      if (this.$store.getters.getRole == "Administrator"){
        this.isAdmin = true;
      }
    },

    checkPage: async function(){
      let token = this.$store.getters.getToken;
      const id = this.$route.query.id;
      if(this.$route.name == "ViewSubmittedQPR"){
        this.showSubmitted = true;
      } else {
        this.showReview = true;
      }
                  
      if (id) {
        const comp = this.$refs.filterDropdown[0];
        if (comp && comp.$el) {
          const input = comp.$el.querySelector('input');
          input.value = 'QPR Number';
          input.dispatchEvent(new Event('input')); 
        }
        this.qprFilterOptions[0].set = true;
        this.qprFilterOptions[0].options[0].selected = true;
        this.filterVal[0] = id;
        await this.setVal("QPRnumber0");
        await this.setFilterVal(0, id);
        await this.searchFilter();

        let query = "filters[id][$eq][0]=" + id;
        const response = await DatabaseLib.getRequest('strapiDatabase','submitted-qpr',token,query,false);
        let data = response.data.data[0];
        if(data.attributes.authorUsername == this.$store.getters.getUser){
          this.qprNumber = data.id;
          this.title = data.attributes.title;
          this.dateCreated = data.attributes.dateSubmitted;
          this.author = data.attributes.author;
          this.foundIn = data.attributes.foundIn;
          this.softwareVersion = data.attributes.softwareVersion;
          this.foundDuring = data.attributes.foundDuring;
          this.currentFunction = data.attributes.currentFunction;
          this.pmComments = data.attributes.pmComments;
          this.expectedFunction = data.attributes.expectedFunction;
          this.priority = '';
          this.userAssignedPriority = data.attributes.submissionPriority;
          this.companyName = data.attributes.company;
          this.showClosed = data.attributes.closed;
          this.authorUsername = data.attributes.authorUsername;
          this.status = data.attributes.status;
          this.dateReviewed = data.attributes.dateReviewed;
          this.approvingPM = data.attributes.approvingPM;

          document.getElementById('showClosed').checked = this.showClosed;

          this.previewing = true;
          this.$nextTick(function() {
            this.$refs.preview.scrollIntoView({behavior: 'smooth'})
          })
        }   
      } 
      await this.populateQPRData();
    },
  },
  computed:{
    getFilterArray(){
      let arr = [];
      let options = [];
      for(var i = 0; i < 7; i++){
        options = [{text: "QPR Number", value: "QPRnumber"+i},{text: "Title", value: "title"+i},{text:"Found In", value: "foundIn"+i},{text:"Version", value: "version"+i},
          {text: "Found During", value: "foundDuring"+i},/*{text:"Constraint On", value: "constraintOn"+i},*/
          {text: "Disposition", value: "disposition"+i}];
        arr.push({id: i, options: options, set: false});  
      }
      return arr
    }
  },

  beforeMount(){
    this.qprFilterOptions = this.getFilterArray;
  },

  mounted() {
    this.checkPM();
    this.checkPage();
  }
}
</script>
